import React, {
    createRef,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import {useToast} from "../ui/use-toast"; // Додайте цей імпорт, якщо ви ще цього не зробили
import {CardDescription, CardHeader, CardTitle} from "../ui/card";
import {Separator} from "../ui/separator";
import {Button} from "../ui/button";
import {

    getBidConfig,
    listBidConfigs,
    updateBidConfig,
} from "../../api/bid_config_api";
import {useAuthInfo} from "@propelauth/react";
import {useParams} from "react-router-dom";
import {
    BidConfigMetaData,
    Cell,
    cellsDecoder,
    cellsEncoder, DataSheetConfig,
} from "./bidConfig_model";
import DataSheet, {make_blank_sheet} from "./DataSheet";
import {Switch} from "../ui/switch";
import {fetchWithToken, postWithToken} from "../../api/apiBase";
import { CopyButton2 } from "../exportData/CopyButton";
import { copySheetDataToClipboard } from "./datasheetHelpers";
import PasteFromExcel from "./PasteFromExcel";

/**
 We might want something like this...

 // const [data, setData] = useState<Matrix<>>([
 //     [{ value: "Division 01" }, { value: "" }, { value: "", party:1 }],
 //     [{ value: "Division 02" }, { value: "" }, { value: "", party:1 }],
 //     [{ value: "Division 03" }, { value: "Concrete" }, { value: "", party:1 }],
 //     [{ value: "Division 04" }, { value: "Masonry" }, { value: "", party:1 }],
 //     [{ value: "Division 05" }, { value: "Metals" }, { value: "", party:1 }],
 //     [{ value: "Division 06" }, { value: "Rough Carp" }, { value: "", party:1 }],
 //     [{ value: "Division 07" }, { value: "Facade" }, { value: "", party:1 }],
 // ]);

 React is not the tool for the job... but SO WAHT???
 */


/**
 *
 * */
export function DevBidFormConfig() {

    const {toast} = useToast();
    const {project_id, scope_id} = useParams<{ project_id: string, scope_id:string }>();
    const {accessToken} = useAuthInfo();
    const [data, setData] = useState<Cell[][]>([]);
    const [templateInfo, setTemplateInfo] = useState<BidConfigMetaData | null>(null);
    const [allConfigs, setAllConfigs] = useState<BidConfigMetaData[]>([])
    // const [activeTemplate]
    const [active, setActive ] = useState<boolean|null>(null);
    const [hist, setHist] = useState([]);

    useEffect(() => {
        const fetchBidConfigs = async () => {
            try {
                if (!project_id || !accessToken) return;

                if (scope_id) {
                    const config: DataSheetConfig | null = await fetchWithToken(
                        `/projects/${project_id}/scope/${scope_id}/bid_config`, accessToken)
                    // console.log(config);
                    if(!config){
                        setData(make_blank_sheet());
                        return
                    }
                    const formattedData = cellsDecoder(config.cells);
                    setData(formattedData);
                    setHist([])
                    setTemplateInfo(config);

                    // setAllConfigs(response)
                } else {

                    const response = await listBidConfigs(project_id, accessToken);
                    // if there is nothing already setup, create a new Grid - and user
                    if (response.length === 0) {
                        setData(make_blank_sheet());
                    } else {

                        // For now - we just assume there is one per project - which should be fine tbh
                        const config = await getBidConfig(project_id, response[0].id, accessToken);
                        const formattedData = cellsDecoder(config.cells);
                        setData(formattedData);
                        setHist([])
                        setTemplateInfo(response[0]);
                        // console.log(response[0])
                        setAllConfigs(response)
                    }
                }

            } catch (err) {
                console.error("Failed to fetch bid configs", err);
            }
        };
        fetchBidConfigs();
    }, [project_id, scope_id]);

    const Save = () => {
        if (!project_id || !accessToken) return;
        let url;
        let response;
        if (!templateInfo) {
            // todo - not sure if this works - for developer ...
            // need to do some template selection stuff.
            let body = {
                name: "",
                is_template: true,
                cells: cellsEncoder(data),
                history: hist,
            }
            if (!scope_id){
                url = `/projects/${project_id}/bid_config/create`
            } else {
                url = `/projects/${project_id}/scopes/${scope_id}/bid_config/create`
            }

            postWithToken(url, JSON.stringify(body), accessToken)
                .then(() => {
                    toast({
                        title: "Success!",
                        description: "The Bid configuration is created.",
                        duration: 5000,
                    });
                })
                .catch((err: any) => {
                    console.error(err);
                    toast({
                        title: "Error!",
                        description: "The Bid configuration could not be created.",
                        duration: 5000,
                        variant: "destructive",
                    });
                });
        } else {
            /// This works
            updateBidConfig(project_id, templateInfo.id, accessToken, {
                name: "",
                is_template: true,
                cells: cellsEncoder(data),
                history: hist,
            })
                .then(() => {
                    toast({
                        title: "Success!",
                        description: "The configuration is updated.",
                        duration: 5000,
                    });
                    setHist([])
                })
                .catch((err: any) => {
                    console.error(err);
                    toast({
                        title: "Error!",
                        description: "The configuration could not be updated.",
                        duration: 5000,
                        variant: "destructive",
                    });
                    setHist([])
                });
        }
    };

    const Clear = () => {
    };

    const onSetTemplateActive = () => {
        if(templateInfo && accessToken) {
            templateInfo.is_active = !templateInfo.is_active
            console.log(templateInfo.is_active)
            setTemplateInfo({...templateInfo})
            postWithToken(
                `/projects/${project_id}/bid_config/${templateInfo.id}/activate`,
                JSON.stringify({value:templateInfo.is_active}),
                accessToken
            )
                .then((_) => {
                     toast({
                        title: "Success!",
                        description: "The Bid configuration is set",
                        duration: 5000,
                    });
                })
        }
    }

    const onSelectTemplate = () => {}
    const onSetProjectTemplate = () => {}
    const onAddTemplate = () => {}

    const exportToExel = () => {
        return data
    }
    
    const pasteDataFromExcel = (pasteData: any[]) => {
        const formattedData = cellsDecoder(pasteData);
    
        const currentColumns = data.length > 0 ? data[0].length : 0;
        const newColumns = formattedData.length > 0 ? formattedData[0].length : 0;
    
        if (newColumns > currentColumns) {
            const normalizedData = formattedData.map((row) => {
                const newRow = [...row];
    
                while (newRow.length < newColumns) {
                    newRow.push({ value: '', party: false }); 
                }
                return newRow;
            });
    
            const updatedData = data.map((row) => {
                const newRow = [...row];
    
                while (newRow.length < newColumns) {
                    newRow.push({ value: '', party: false });
                }
                return newRow;
            });
    
            setData((prevData) => [...updatedData, ...normalizedData]);
    
        } else if (newColumns === currentColumns) {
            setData((prevData) => [...prevData, ...formattedData]);

        } else {
            const normalizedData = formattedData.map((row) => {
                const newRow = [...row];
                
                while (newRow.length < currentColumns) {
                    newRow.push({ value: '', party: false });
                }
        
                if (newRow.length > 0) {
                    newRow[newRow.length - 1].party = true;
                }
        
                return newRow;
            });
        
            setData((prevData) => [...prevData, ...normalizedData]);
        }
    };

    return (
        <>
            <CardHeader>
                <CardTitle className="flex justify-between columns-2">
                    <div>Bid Setup</div>
                     <div className="flex gap-2 items-center">
                        <div>
                        </div>
                        Activate Bid Template
                        <Switch
                            checked={templateInfo?.is_active}
                            onCheckedChange={onSetTemplateActive}
                        />
                        <Button variant="outline" disabled={!hist || hist.length===0} onClick={Save}>
                            Save
                        </Button>

                        {/*<Button variant="outline" onClick={Clear}>*/}
                        {/*    Delete*/}
                        {/*</Button>*/}
                    </div>
                </CardTitle>
                <CardDescription>
                    Configure additional fields bidders will need to provide
                </CardDescription>
                <Separator/>

            </CardHeader>
            <div className="columns-2 w-full flex">
                <div className="w-10/12 relative">
                <div className="absolute flex gap-2">
                <CopyButton2 dataTransform={exportToExel} executeCustomCopy={copySheetDataToClipboard}></CopyButton2>
                <PasteFromExcel pasteDataFromExcel={pasteDataFromExcel}/>
                </div>
                <DataSheet
                    data={data}
                    setData={setData}
                    enable_row_col={true}
                    readonly={false}
                    hist={hist}
                    setHist={setHist}
                />
                    </div>
                {/*<div>*/}
                {/*    {hist.map((x, i) =>*/}
                {/*        <div key={i}>{JSON.stringify(x)}</div>*/}
                {/*    )}*/}
                {/*</div>*/}
                </div>
        </>
    );
}


